import React from 'react'
import { Box, Grid, Paper, Card, CardActionArea, CardContent, Typography, Chip, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom';

import { ReactComponent as BuyerLogo } from '../../assets/images/customers.svg';
import { ReactComponent as MakeLogo } from '../../assets/images/make.svg';
import { ReactComponent as ModelLogo } from '../../assets/images/model.svg';
import { ReactComponent as ColorLogo } from '../../assets/images/color.svg';
import { ReactComponent as FuelLogo } from '../../assets/images/fule.svg';
import { ReactComponent as PortsLogo } from '../../assets/images/port.svg';
import { ReactComponent as DestinationLogo } from '../../assets/images/dest.svg';
import { ReactComponent as VehiclesLogo } from '../../assets/images/type.svg';
import { ReactComponent as UsersLogo } from '../../assets/images/users.svg';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import OutboxIcon from '@mui/icons-material/Outbox';
import BadgeIcon from '@mui/icons-material/Badge';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import HandshakeIcon from '@mui/icons-material/Handshake';
const Management = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const items = [
        { icon: <UsersLogo />, name: 'Users', linkLabel: 'Users List', onClick: () => navigate('/user/userList') },
        { icon: <BuyerLogo />, name: 'Clients', linkLabel: 'Client List', onClick: () => navigate('/client/clientList') },
        { icon: <DestinationLogo />, name: 'Destination', linkLabel: 'Destination List', onClick: () => navigate('/destination/view') },
        { icon: <VehiclesLogo />, name: 'Vehicles Type', linkLabel: 'Vehicles Type List', onClick: () => navigate('/vehicleType/view') },
        { icon: <MakeLogo />, name: 'Make', linkLabel: 'Make List', onClick: () => navigate('/make/list') },
        { icon: <ModelLogo />, name: 'Models', linkLabel: 'Models List', onClick: () => navigate('/model/list') },
        { icon: <FuelLogo />, name: 'Fuel Type', linkLabel: 'Fuel Type List', onClick: () => navigate('/fuelType/view') },
        { icon: <ColorLogo />, name: 'Color', linkLabel: 'Color List', onClick: () => navigate('/color/view') },
        { icon: <LocalShippingIcon />, name: 'Transport Company', linkLabel: 'Transport Company List', onClick: () => navigate('/transportCompany/view'), stroke: true },
        { icon: <DirectionsBoatIcon />, name: 'Shipping Company', linkLabel: 'Shipping Company List', onClick: () => navigate('/shippingLine/view'), stroke: true },
        { icon: <PortsLogo />, name: 'Ports Loading', linkLabel: 'Ports Loading List', onClick: () => navigate('/portLoading/view') },
        { icon: <MoveToInboxIcon />, name: 'Pickup Terminal', linkLabel: 'Pickup Terminal List', onClick: () => navigate('/pickupTerminal/view'), stroke: true },
        { icon: <OutboxIcon />, name: 'Return Terminal', linkLabel: 'Return Terminal List', onClick: () => navigate('/returnTerminal/view'), stroke: true },
        { icon: <BadgeIcon />, name: 'Consignee', linkLabel: 'Consignee List', onClick: () => navigate('/consignee/list'), stroke: true },
        { icon: <WarehouseIcon />, name: 'Consignee Dock', linkLabel: 'Consignee Dock List', onClick: () => navigate('/consigneeDock/view'), stroke: true },
        { icon: <HandshakeIcon />, name: 'Broker', linkLabel: 'Broker List', onClick: () => navigate('/broker/view'), stroke: true },


            ];

    return (
        <Paper  sx={{ p: { xs: 1, md: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: isMobile ? 1 : 2 }}>
                <SettingsApplicationsIcon sx={{ mr: 1, color: 'primary.main' }} />
                <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ fontWeight: 700 }}>Management</Typography>
            </Box>

            <Grid container spacing={isMobile ? 1.5 : 2}>
                {items.map((item, idx) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={`${item.name}-${idx}`}>
                        <Card variant="outlined" sx={{
                            height: '100%',
                            borderRadius: 2,
                            transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                            '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 24px rgba(11,60,93,0.10)' }
                        }}>
                            <CardActionArea onClick={item.onClick} sx={{ height: '100%', minHeight: isMobile ? 92 : 'auto' }}>
                                <CardContent sx={{ p: isMobile ? 1.25 : 2 }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: isMobile ? 56 : 64,
                                        height: isMobile ? 56 : 64,
                                        borderRadius: '50%',
                                        bgcolor: 'grey.100',
                                        mb: isMobile ? 1 : 1.5
                                    }}>
                                        {/* SVG icon rendered inside a sized container */}
                                        <Box sx={{
                                            width: isMobile ? 28 : 36,
                                            height: isMobile ? 28 : 36,
                                            '& svg': { width: '100%', height: '100%' },
                                            ...(item.stroke ? { '& svg path': { fill: 'transparent', stroke: 'currentColor', strokeWidth: 1.8 } } : {})
                                        }}>
                                            {item.icon}
                                        </Box>
                                    </Box>
                                    <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} noWrap title={item.name} sx={{ fontWeight: 600 }}>
                                        {item.name}
                                    </Typography>
                                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                        <Chip size="small" label={item.linkLabel} variant="outlined" sx={{ borderRadius: 1, maxWidth: '100%', '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                        <ArrowForwardIosIcon sx={{ fontSize: 14, color: 'text.secondary', flexShrink: 0 }} />
                                    </Box>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}

export default Management